'use strict';

var _classCallCheck = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _slicedToArray = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('./error'),
    TimeoutError = _require.TimeoutError,
    AbortError = _require.AbortError;

var _require2 = require('../fetch'),
    Response = _require2.Response,
    Request = _require2.Request,
    Headers = _require2.Headers,
    fetch = _require2.default;
/**
 * @typedef {import('../types').FetchOptions} FetchOptions
 * @typedef {import('../types').ProgressFn} ProgressFn
 */

/**
 * Fetch with progress
 *
 * @param {string | Request} url
 * @param {FetchOptions} [options]
 * @returns {Promise<ResponseWithURL>}
 */


var fetchWithProgress = function fetchWithProgress(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var request = new XMLHttpRequest();
  request.open(options.method || 'GET', url.toString(), true);
  var timeout = options.timeout,
      headers = options.headers;

  if (timeout && timeout > 0 && timeout < Infinity) {
    request.timeout = timeout;
  }

  if (options.overrideMimeType != null) {
    request.overrideMimeType(options.overrideMimeType);
  }

  if (headers) {
    var _iterator = _createForOfIteratorHelper(new Headers(headers)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            name = _step$value[0],
            value = _step$value[1];

        request.setRequestHeader(name, value);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (options.signal) {
    options.signal.onabort = function () {
      return request.abort();
    };
  }

  if (options.onUploadProgress) {
    request.upload.onprogress = options.onUploadProgress;
  } // Note: Need to use `arraybuffer` here instead of `blob` because `Blob`
  // instances coming from JSDOM are not compatible with `Response` from
  // node-fetch (which is the setup we get when testing with jest because
  // it uses JSDOM which does not provide a global fetch
  // https://github.com/jsdom/jsdom/issues/1724)


  request.responseType = 'arraybuffer';
  return new Promise(function (resolve, reject) {
    /**
     * @param {Event} event
     */
    var handleEvent = function handleEvent(event) {
      switch (event.type) {
        case 'error':
          {
            resolve(Response.error());
            break;
          }

        case 'load':
          {
            resolve(new ResponseWithURL(request.responseURL, request.response, {
              status: request.status,
              statusText: request.statusText,
              headers: parseHeaders(request.getAllResponseHeaders())
            }));
            break;
          }

        case 'timeout':
          {
            reject(new TimeoutError());
            break;
          }

        case 'abort':
          {
            reject(new AbortError());
            break;
          }

        default:
          {
            break;
          }
      }
    };

    request.onerror = handleEvent;
    request.onload = handleEvent;
    request.ontimeout = handleEvent;
    request.onabort = handleEvent;
    request.send(
    /** @type {BodyInit} */
    options.body);
  });
};

var fetchWithStreaming = fetch;
/**
 * @param {string | Request} url
 * @param {FetchOptions} options
 */

var fetchWith = function fetchWith(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return options.onUploadProgress != null ? fetchWithProgress(url, options) : fetchWithStreaming(url, options);
};
/**
 * Parse Headers from a XMLHttpRequest
 *
 * @param {string} input
 * @returns {Headers}
 */


var parseHeaders = function parseHeaders(input) {
  var headers = new Headers();

  var _iterator2 = _createForOfIteratorHelper(input.trim().split(/[\r\n]+/)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var line = _step2.value;
      var index = line.indexOf(': ');

      if (index > 0) {
        headers.set(line.slice(0, index), line.slice(index + 1));
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return headers;
};

var ResponseWithURL = /*#__PURE__*/function (_Response) {
  _inherits(ResponseWithURL, _Response);

  /**
   * @param {string} url
   * @param {BodyInit} body
   * @param {ResponseInit} options
   */
  function ResponseWithURL(url, body, options) {
    var _this;

    _classCallCheck(this, ResponseWithURL);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponseWithURL).call(this, body, options));
    Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'url', {
      value: url
    });
    return _this;
  }

  return ResponseWithURL;
}(Response);

module.exports = {
  fetch: fetchWith,
  Request: Request,
  Headers: Headers,
  ResponseWithURL: ResponseWithURL
};